const features = [
  {
    icon: 'ri-links-line',
    title: '最新访问入口',
    description: '实时更新 JavBus 官方域名与可用镜像站点，确保您始终能够顺畅访问平台。',
  },
  {
    icon: 'ri-search-line',
    title: '高效搜索技巧',
    description: '掌握番号查询与高级筛选方法，在海量影片中精准定位目标内容。',
  },
  {
    icon: 'ri-book-open-line',
    title: '完整使用教程',
    description: '从零开始的详细指南，覆盖平台各项功能，帮助新手快速上手使用。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全使用指导',
    description: '保护个人隐私，识别官方站点，防范钓鱼风险，安心使用平台服务。',
  },
];

export default function Features() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择我们的指南
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            全面覆盖 JavBus 平台使用所需的各类信息，助您快速成为平台使用达人
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 text-center hover:bg-background-100 transition-colors cursor-default animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}